var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-box"},[_c('div',{staticClass:"header-top"},[_c('header-top')],1),_c('logo-box'),_c('nav-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }